import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "selected-car" }
const _hoisted_2 = { class: "me-2" }
const _hoisted_3 = {
  key: 0,
  class: "change-car mt-4"
}
const _hoisted_4 = { class: "list-group list-group-flush" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "list-group-item list-group-item-light d-flex justify-content-end" }, " Wybierz samochód: ", -1)
const _hoisted_6 = {
  key: 0,
  class: "container additional-info"
}
const _hoisted_7 = { class: "gray-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Carspot24", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:kontakt@carspot24.pl" }, "kontakt@carspot24.pl", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_refreshing_arrows_icon = _resolveComponent("refreshing-arrows-icon")!
  const _component_car_details_for_selection = _resolveComponent("car-details-for-selection")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "elements",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChangeCar && _ctx.toggleChangeCar(...args)))
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getSelectedCar.makeName) + " " + _toDisplayString(_ctx.getSelectedCar.rangeName), 1),
        _createVNode(_component_refreshing_arrows_icon, { class: "me-4" })
      ]),
      (_ctx.isChangedCar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              _hoisted_5,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCars, (car) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-group-item",
                  key: car.typeId
                }, [
                  _createVNode(_component_car_details_for_selection, {
                    car: car,
                    onCarChanged: _ctx.toggleChangeCar
                  }, null, 8, ["car", "onCarChanged"])
                ]))
              }), 128)),
              (_ctx.getCars && _ctx.getCars.length < _ctx.getLimit)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "list-group-item d-flex add-next justify-content-end bold",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNextCar && _ctx.addNextCar(...args)))
                  }, " + Dodaj kolejny samochód "))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isChangedCar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(" W ramach konta "),
            _hoisted_8,
            _createTextVNode(" masz "),
            _createElementVNode("b", null, "limit " + _toDisplayString(_ctx.getLimit), 1),
            _createTextVNode(" samochodów. Dodaj za pomocą VIN, albo wybierz wg. marka-model-wersja. Jeśli się pomylisz, napisz na "),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}